import { commentItems } from '@/mocks/animeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            漫友热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来看看漫友们都在说什么，真实用户口碑见证
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-[960px] mx-auto">
          {commentItems.map((comment) => (
            <div
              key={comment.name}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="flex items-start gap-3 md:gap-4 mb-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0 bg-secondary-100">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.currentTarget as HTMLImageElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-medium text-foreground-800">
                      {comment.name}
                    </span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <div className="flex items-center gap-1 text-accent-500">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-xs"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
              <div className="flex items-center gap-1 mt-3 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}